import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { stateConvert } from "utils/stateAbbreviation";
import {
  adminUpdateUserApi,
  checkIsZipCode,
} from "redux/actions/manageAccount";
import {
  Container,
  GridContainer,
  InputFieldsWrapper,
} from "styles/pages/manage-account";
import TextInput from "components/FormElements/TextInput";
import PhoneNumber from "components/FormElements/PhoneNumber";
import EditIcon from "assets/svg/PtPlusUserViewEditIcon";
import { Tooltip } from "reactstrap";
import information from "assets/images/informationIcon.png";
import { useText } from "locales/useGetText";
import AlertModal from "components/AlertModal";
import { getStateAbbr, getLoggedInUserCountry } from 'helpers'

function BillTo(pageProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locale = useText("manageAccount");
  const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserData"));
  const token = loggedInUserInfo?.token;
  const userCountry = getLoggedInUserCountry();
  const [saveDisableState, setSaveDisableState] = useState(true);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidZip, setIsValidZip] = useState(true);
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");

  useEffect(() => {
    if (pageProps.pageData) resetFieldsFunction(pageProps.pageData);
  }, [pageProps.pageData]);

  useEffect(() => {
    let fieldValues = pageProps.formikProps.values;
    let errorkeys = [];
    if (pageProps.formikProps?.errors) {
      errorkeys = Object.keys(pageProps.formikProps.errors);
    }
    let pageErrors = false;
    if (
      errorkeys.length < 15 &&
      (pageProps.formikProps?.errors?.billToPhoneNumber ||
        pageProps.formikProps?.errors?.billToEmail ||
        pageProps.formikProps?.errors?.otherContactEmail)
    )
      pageErrors = true;
    if (
      isValidZip &&
      isValidEmail &&
      !pageErrors &&
      fieldValues.billToUserName.trim() !== "" &&
      fieldValues.billToPhoneNumber.trim() !== "" &&
      fieldValues.billToBusinessName.trim() !== "" &&
      fieldValues.billToEmail.trim() &&
      fieldValues.billToAddress.trim() !== "" &&
      fieldValues.billToCity.trim() !== "" &&
      fieldValues.billToState.trim() !== "" &&
      fieldValues.billToZip.trim() !== ""
    ) {
      setSaveDisableState(false);
    } else setSaveDisableState(true);
  }, [pageProps.formikProps, pageProps.errors, isValidEmail, isValidZip]);

  const [tooltip, setTooltip] = useState(false);
  const [tooltipSection, setTooltipSection] = useState("");
  const iIcon = (infoSection, infoTxt) => {
    return (
      <>
        <img
          id={infoSection}
          src={information}
          style={{ position: "relative", top: "2px", left: "-5px" }}
        />
        <Tooltip
          placement="right"
          isOpen={tooltip && tooltipSection === infoSection}
          target={infoSection}
          toggle={() => {
            setTooltip(!tooltip);
            setTooltipSection(tooltipSection === "" ? infoSection : "");
          }}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };

  const updateApiFunction = async () => {
    let id = pageProps.pageData.id;
    let url = `/user/bill_to_update/${id}`;
    let fieldValues = pageProps.formikProps.values;
    let response = "";
    let data = {
      billToEmailAddress: fieldValues.billToEmail?.trim(),
      otherContactEmail: fieldValues.otherContactEmail
        ? fieldValues.otherContactEmail.trim()
        : null,
      address: {
        name: fieldValues.billToBusinessName?.trim(),
        contactNumber: fieldValues.billToPhoneNumber?.trim(),
        locationName: fieldValues.billToBusinessName?.trim(),
        street: fieldValues.billToAddress?.trim(),
        city: fieldValues.billToCity?.trim(),
        state: fieldValues.billToState?.trim(),
        zipCode: fieldValues.billToZip?.trim(),
      },
    };
    response = await dispatch(adminUpdateUserApi(url, data, token));
    if (response.success) {
      setAlertModalContent(
        locale('defaultPreferencesInfo')
      );
      setAlertModal(!alertModal);
    } else {
      if (
        response?.data?.error?.message === "Invalid Token" ||
        response.message === "Request failed with status code 401"
      ) {
        navigate("/");
      } else {
        setAlertModalContent(response.message);
        setAlertModal(!alertModal);
      }
    }
  };

  const zipChangeHandler = async (value) => {
    let response = "";
    if (value.length === 5) {
      response = await dispatch(checkIsZipCode(value, token));
      if (response.success) {
        setIsValidZip(true);
        let stateAbb = stateConvert(response.data?.state);
        pageProps.setFieldValue(
          "billToState",
          stateAbb || response.data?.state
        );
        pageProps.setFieldValue("billToCity", response.data?.city);
      } else {
        if (response?.data?.error?.message === "Invalid Zip Code.") {
          setIsValidZip(false);
          pageProps.setFieldValue("billToState", "");
          pageProps.setFieldValue("billToCity", "");
        } else if (
          response.error?.message === "Invalid token" ||
          response.message === "Request failed with status code 401"
        ) {
          navigate("/");
        } else {
          setAlertModalContent(
            response.message || locale('genericError')
          );
          setAlertModal(!alertModal);
        }
      }
    } else {
      setIsValidZip(true);
      pageProps.setFieldValue("billToState", "");
      pageProps.setFieldValue("billToCity", "");
    }
  };

  const resetFieldsFunction = (initailValues) => {
    let initailData;
    if (initailValues) initailData = initailValues;
    else initailData = pageProps.pageData;
    if (initailData) {
      pageProps.setFieldValue(
        "billToBusinessName",
        initailData?.billingAddress?.locationName || ""
      );
      pageProps.setFieldValue(
        "billToAddress",
        initailData?.billingAddress?.street
      );
      pageProps.setFieldValue("billToCity", initailData?.billingAddress?.city);
      pageProps.setFieldValue(
        "billToState",
        stateConvert(initailData.billingAddress?.state) ||
        initailData.billingAddress?.state
      );
      pageProps.setFieldValue(
        "billToZip",
        initailData?.billingAddress?.zipCode
      );
      pageProps.setFieldValue(
        "billToPhoneNumber",
        initailData?.billingAddress?.contactNumber || ""
      );
      pageProps.setFieldValue(
        "billToUserName",
        initailData.billingAddress?.name
      );
      pageProps.setFieldValue(
        "billToEmail",
        initailData?.billToEmailAddress || ""
      );
      pageProps.setFieldValue(
        "otherContactEmail",
        initailData?.otherContactEmail || ""
      );
    }
  };

  return (
    <>
      <Container>
        {/* <AccordionHeader>
                    <h6 onClick={() => {
                        if (accordionOpen) setAccordionOpen(false)
                        else setAccordionOpen(true)
                    }}>Bill-To Information</h6>
                    {accordionOpen ?
                        <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
                        : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
                    }
                </AccordionHeader> */}
        {/* {accordionOpen && */}
        <GridContainer>
          <h6 onClick={() => { }}>{locale('billToInformation')}</h6>
          {/* {accordionOpen ? */}
          <InputFieldsWrapper>
            <div className="row">
              <div className="col-md-4 fixed-height">
                <div className="height-adjust">
                  <TextInput
                    name="billToBusinessName"
                    disabled
                    placeholder={locale('billToCompanyName')}
                    inputType="CompanyName"
                  />
                </div>
              </div>
              <div className="col-md-4 fixed-height">
                <div className="height-adjust">
                  <TextInput
                    name="billToAddress"
                    disabled
                    placeholder={locale('address')}
                    maxLength={200}
                    inputType="addressText"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 fixed-height">
                <div className="height-adjust">
                  <TextInput
                    name="billToCity"
                    disabled
                    placeholder={locale('city')}
                    inputType="onlyText"
                  />
                </div>
              </div>
              <div className="col-md-4 fixed-height">
                <div className="height-adjust">
                  <TextInput
                    name="billToState"
                    placeholder={userCountry === 'CANADA' ? locale('province') : locale('state')}
                    disabled
                    inputType="text"
                  />
                </div>
              </div>
              <div
                className={
                  !isValidZip
                    ? "col-md-4 fixed-height error-styling-input"
                    : "col-md-4 fixed-height"
                }
              >
                <div className="height-adjust">
                  <TextInput
                    name="billToZip"
                    disabled
                    placeholder={userCountry === 'CANADA' ? locale('postalCode') : locale('zip')}
                    maxLength={userCountry === 'CANADA' ? 7 : 5}
                    onChangeHandler={zipChangeHandler}
                    inputType="returnText"
                  />
                  {!isValidZip && (
                    <p style={{ marginTop: "-1px" }}>{locale('zipInvalid')}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 fixed-height">
                <div className="height-adjust">
                  <TextInput
                    name="billToUserName"
                    disabled
                    placeholder={locale('contactFullName')}
                    inputType="onlyText"
                  />
                </div>
              </div>
              <div
                className={
                  !isValidEmail
                    ? "col-md-4 fixed-height error-styling-input"
                    : "col-md-4 fixed-height"
                }
              >
                <div
                  className="height-adjust"
                  style={{ display: "grid", gridTemplateColumns: "15fr 1fr" }}
                >
                  <div>
                    <TextInput
                      name="billToEmail"
                      disabled
                      placeholder={locale('contactEmail')}
                    />
                    {!isValidEmail && (
                      <p style={{ marginTop: "-7px" }}>{locale('emailAlreadyExists')}</p>
                    )}
                  </div>
                  <div>
                    {iIcon("billToEmail", locale('contactEmailTooltip'))}
                  </div>
                </div>
              </div>
              <div
                className={
                  !isValidEmail
                    ? "col-md-4 fixed-height error-styling-input"
                    : "col-md-4 fixed-height"
                }
              >
                <div
                  className="height-adjust"
                  style={{ display: "grid", gridTemplateColumns: "15fr 1fr" }}
                >
                  <div>
                    <TextInput
                      name="otherContactEmail"
                      disabled
                      placeholder={locale('otherContactEmail')}
                    />
                    {!isValidEmail && (
                      <p style={{ marginTop: "-7px" }}>{locale('emailAlreadyExists')}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-4 fixed-height">
                <div className="height-adjust">
                  <PhoneNumber
                    name="billToPhoneNumber"
                    disabled
                    placeholder={locale('contactPhoneNumber')}
                  />
                </div>
              </div>
            </div>
          </InputFieldsWrapper>
        </GridContainer>
        {/* } */}
      </Container>

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        // title="Alert"
        content={alertModalContent}
        link={modalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
      />
    </>
  );
}

export default BillTo;
